"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_web_components_1 = require("@nimles/react-web-components");

var RadioLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  align-items: center;\n"], ["\n  display: flex;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  align-items: center;\n"])));
var RadioInput = styled_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: auto;\n  margin: 0 0.4em 0 0;\n"], ["\n  display: inline-block;\n  width: auto;\n  margin: 0 0.4em 0 0;\n"])));

var StandardInput = function StandardInput(_a) {
  var field = _a.field,
      // { name, value, onChange, onBlur }
  _b = _a.form,
      touched = _b.touched,
      errors = _b.errors,
      setFieldValue = _b.setFieldValue,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  options = _a.options,
      label = _a.label,
      required = _a.required,
      info = _a.info;
  return react_1.default.createElement(react_1.default.Fragment, null, label && react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label), react_1.default.createElement("div", null, options.map(function (option, index) {
    return react_1.default.createElement(RadioLabel, {
      key: index
    }, react_1.default.createElement(RadioInput, {
      type: "radio",
      name: field.name,
      value: option.value,
      checked: field.value === option.value,
      onChange: function onChange() {
        return setFieldValue(field.name, option.value);
      }
    }), option.name);
  }), react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.RadioField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: StandardInput
  }));
};

var templateObject_1, templateObject_2;